
function filterBlogPosts(event) {
    const buttonId = event.target.id;
    const elements = document.querySelectorAll('.posts-container > *');
    const buttons = document.querySelectorAll('.filter'); 
    
   //set button to default css
    buttons.forEach(button => {
        button.classList.remove('bg-green2025-100', 'text-white');
        button.classList.add('bg-white', 'text-green2025-100');
    });

    // change css of selected button
    const button = document.getElementById(buttonId);
    button.classList.remove('bg-white', 'text-green2025-100');
    button.classList.add('bg-green2025-100', 'text-white' );
    let found = false;

    // display only element that match selected filter button
    elements.forEach(element => {
        const dataTag = element.getAttribute('data-tag');
        if (dataTag === buttonId || buttonId === "allArticles") {
            element.classList.remove('hidden');
            found = true;
        } else {
            element.classList.add('hidden')
        }    
    });


    // clear no-article-message
    const previousMessage = document.querySelector('.no-articles-message');
    if (previousMessage) {
        previousMessage.remove();
    }

    // display no-article-message if selected category is empty
    if (!found) {
        elements.forEach(element => {
            element.classList.add('hidden');
        });
        const container = document.querySelector('.posts-container');
        let message = document.createElement('p');
        message.className = 'mt-8 no-articles-message';
        message.textContent = 'There currently are no articles in this category.';
        container.appendChild(message);
    }
};

document.addEventListener("DOMContentLoaded", function () {

    const buttons = document.querySelectorAll('.filter');

    buttons.forEach(button => {
        button.addEventListener('click', filterBlogPosts);
    });

    document.querySelectorAll('.article-card').forEach(function(card) {
        // add hover effect on card to display read-more-arrow
        card.addEventListener('mouseenter', function() {
            var arrow = card.querySelector('.read-more-arrow');
            if (arrow) {
                arrow.classList.remove('hidden');
            }
        });
        card.addEventListener('mouseleave', function() {
            var arrow = card.querySelector('.read-more-arrow');
            if (arrow) {
                arrow.classList.add('hidden');
            }
        });
        
        // always display read-more-arrow form tablet downwards
        if (window.innerWidth <= 768) {
            var arrow = card.querySelector('.read-more-arrow');
            if (arrow) {
                arrow.classList.remove('hidden');
            }
        }
    });
});
